// Single source of truth for the API's base URL, instead of the same
// literal string typed out (and sometimes commented-out-with-a-localhost-
// alternative-beside-it) in every file that calls the API. Override locally
// with REACT_APP_API_BASE_URL in .env.local if you need to point at a
// local server during development.
export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://ekhoni-khabo-server.vercel.app/api/v1";
